/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * How the feature appears in the pricing comparison table.
 */
export type PlanFeatureFlagResponseDisplay = typeof PlanFeatureFlagResponseDisplay[keyof typeof PlanFeatureFlagResponseDisplay];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanFeatureFlagResponseDisplay = {
  none: 'none',
  included: 'included',
  limited: 'limited',
  basic: 'basic',
  advanced: 'advanced',
  custom: 'custom',
} as const;
